import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import ItemHuman from 'components/ItemHuman';
import Avatar from 'components/Avatar';

export default class ItemPerson extends MainComponent {
    static propTypes = {
        type: PropTypes.string,
        info: PropTypes.object,
        firstRow: PropTypes.string,
        secondRow: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    };
    static defaultProps = {
        type: "",
        info: {},
        firstRow: "",
        secondRow: "",
    };

    render() {
        const { className, type, info, firstRow, secondRow } = this.props;
        const { sex, specs, photoUid } = info;

        const cl = className ? ` ${className}` : "";
        const firstSpec = (specs && specs[0]) ? specs[0] : {};

        const fRow = firstRow ? firstRow : this._helper.string.formatFullName(info, type);
        const secRow = secondRow ? secondRow : (firstSpec?.specEntity?.title || "");

        return (
            <ItemHuman
                {...this.props}
                className={"itemPerson" + cl}
                firstRow={fRow}
                secondRow={secRow}
                iconLeft={<Avatar id={photoUid} sex={sex} />}
            />
        );
    }
}
